import { render } from "./CurrentTariffCard.vue?vue&type=template&id=38010967&scoped=true"
import script from "./CurrentTariffCard.vue?vue&type=script&lang=js"
export * from "./CurrentTariffCard.vue?vue&type=script&lang=js"

import "./CurrentTariffCard.vue?vue&type=style&index=0&id=38010967&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38010967"]])

export default __exports__